import { IRootState } from '../reducer'
import { prefix } from './actions'

export const isLoading = (state: IRootState) => state[prefix].loadingArray.length > 0

export const lastNotifications = (state: IRootState) => state[prefix].lastNotifications

// The Notifications page's four tabs, each holding its own loaded rows.
export const notificationsByHome = (state: IRootState) => state[prefix].notifications.byHome

// Whole-account unread counts, shared by every tab (see INotificationsState).
export const notificationCounts = (state: IRootState) => state[prefix].notifications.counts
